"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPaintSystemSetting = exports.renamePaintSystem = exports.removePaintSystem = void 0;
exports.addPaintSystem = addPaintSystem;
exports.setPaintSystemPaint = setPaintSystemPaint;
// Several paint systems on one measured surface, for one option (#412,
// docs/SURFACE-NAMES.md): the fascia measured once, priced as 2 coats of
// Durebuild then 2 coats of Weathermax. The surface's own choices are its
// first system; these are the ones after it, stored with its choices in
// hig_scope. Pure functions only, like option-scope.ts.
const option_scope_ts_1 = require("./option-scope.js");
/** The value without its keys set to undefined (cleared). */
function compact(value) {
    return Object.fromEntries(Object.entries(value).filter(([, v]) => v !== undefined));
}
function withSystems(scope, areaId, surfaceId, change) {
    return (0, option_scope_ts_1.withSurface)(scope, areaId, surfaceId, (s) => {
        const systems = change(s.systems ?? []);
        return { ...s, systems: systems.length ? systems : undefined };
    });
}
const withSystem = (scope, areaId, surfaceId, systemId, change) => withSystems(scope, areaId, surfaceId, (systems) => systems.map((x) => (x.id === systemId ? compact(change(x)) : x)));
/** Add a paint system after the surface's others; it starts from the surface as measured, with no prep. */
function addPaintSystem(scope, areaId, surfaceId, name) {
    const trimmed = name.trim();
    return withSystems(scope, areaId, surfaceId, (systems) => [...systems, { id: crypto.randomUUID(), ...(trimmed && { name: trimmed }) }]);
}
const removePaintSystem = (scope, areaId, surfaceId, systemId) => withSystems(scope, areaId, surfaceId, (systems) => systems.filter((x) => x.id !== systemId));
exports.removePaintSystem = removePaintSystem;
const renamePaintSystem = (scope, areaId, surfaceId, systemId, name) => withSystem(scope, areaId, surfaceId, systemId, (x) => ({ ...x, name: name.trim() || undefined }));
exports.renamePaintSystem = renamePaintSystem;
/** A typed value for one system; null puts it back to the surface's (prep: back to none). */
const setPaintSystemSetting = (scope, areaId, surfaceId, systemId, setting, value) => withSystem(scope, areaId, surfaceId, systemId, (x) => ({ ...x, [setting]: value ?? undefined }));
exports.setPaintSystemSetting = setPaintSystemSetting;
/** A system's paint; the option's first paint stores nothing, as for a surface. */
function setPaintSystemPaint(scope, generic, areaId, surfaceId, systemId, key) {
    const stored = (0, option_scope_ts_1.storedPaint)(scope, generic, key);
    return withSystem(stored.scope, areaId, surfaceId, systemId, (x) => ({ ...x, paint: stored.paint }));
}
